import { useMutation, useQueryClient } from '@tanstack/react-query';

import selectPresetBySlug from '@/utils/preset/selectPresetBySlug';
import { setAppStore } from '@/store';
import { Screen } from '@/types';

const useLibraryItemInfoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (slug: string) => {
      const preset = await selectPresetBySlug(slug, queryClient);

      return { preset, slug };
    },

    onMutate: () => {
      setAppStore({
        isPresetLoading: true,
        screen: Screen.Create,
      });
    },

    onError: () => {
      setAppStore({
        isPresetLoading: false,
        screen: Screen.Library,
      });
    },
  });
};

export default useLibraryItemInfoMutation;
